<div>
    <p-table [value]="duplicateSamples" [scrollable]="true" scrollHeight="100vh"
             styleClass="p-datatable-striped mt-3 mx-1 md:text-sm lg:text-md">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col">Sample ID</th>
                <th scope="col">Project Name</th>
                <th scope="col">Sample Type</th>
                <th scope="col">Activated</th>
                <th scope="col">Gender</th>
                <th scope="col">Announced</th>
                <th scope="col">Unsuitable (Reason)</th>
                <th scope="col">Completed (Date)</th>
                <th scope="col"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sample>
            <tr>
                <td class="text-center">{{sample.barCode ?? sample.animalNumber ?? sample.ittNumber}}</td>
                <td class="text-center">{{sample.projectName}}</td>
                <td class="text-center">{{sample.sampleType}}</td>
                <td class="text-center">{{sample.activated ? "Yes" : "No"}}</td>
                <td class="text-center">{{sample.gender}}</td>
                <td class="text-center">{{sample.announcedDate | date: 'dd.MM.yy'}}</td>
                <td class="text-center">{{sample.receptionStatus === 'REMOVED' ? "Yes (" + sample.receptionIssueReason + ")" : "No" }}</td>
                <td class="text-center">{{sample.sampleCompletionDate !== null ? ("Yes (" + (sample.sampleCompletionDate | date: 'dd.MM.yy') + ")") : "No"}}</td>
                <td class="text-center">
                    <button pButton [disabled]="checkIfSampleIsDisabledForSelection(sample)" (click)="selectedSampleFromDuplicate(sample._id)">Select</button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
